import { render } from "./Flight.vue?vue&type=template&id=89be5734&scoped=true"
import script from "./Flight.vue?vue&type=script&lang=js"
export * from "./Flight.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-89be5734"

export default script